/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResetPassword/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import BackToSignInAction from './BackToSignInAction/index'
import Email from './Email/index'
import HappyToothGraphic from 'DesignSystem/Svgs/HappyToothGraphic/index'
import React from 'react'
import SendCodeAction from './SendCodeAction/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function ResetPassword({
  children,
  viewPath = "/App/Auth/ResetPassword"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<div
  data-testid="ResetPassword.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-TVo3T': isBefore ? 0 : 1,'--tx-2-TVo3T': isBefore ? "-32px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="ResetPassword.Vertical:1"
  data-view-path={viewPath}
 style={{'--w-3-TVo3T': isMedia.mobile ? "340px" : "360px"}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="ResetPassword.Vertical:2"
  data-view-path={viewPath}
 style={{'--mr-4-TVo3T': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical2}`}
>
<HappyToothGraphic
  viewPath={`${viewPath}/HappyToothGraphic`}
 width={80}
 height={80}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 text="Practice Hub"
/>
</div>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="Reset Password"
/>
<Email
  viewPath={`${viewPath}/Email`}
/>
<div
  data-testid="ResetPassword.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-5-TVo3T': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Horizontal}`}
>
<BackToSignInAction
  viewPath={`${viewPath}/BackToSignInAction`}
/>
<SendCodeAction
  viewPath={`${viewPath}/SendCodeAction`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}